import {h, Fragment} from "preact"
import { useActions } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'

import MobileFilter from './MobileFilter'

const facetNameTranslations = {
    category: 'Kategoria',
    brand: 'Producent',
    inStock: 'Available',
}

export default ({ facet, isActive, setActive }) => {
    const { updateSearch } = useActions()

    const selectedFiltersCount = facet.data?.filter((v) => v.selected).length ?? 0

    return (
        <li class={`ns-sidebar-dropdown ${isActive ? 'ns-active' : ''}`}>
            <a
                class="nosto-sidebar-dropdown ns-d-flex ns-justify-content-between ns-align-content-center ns-relative ns-w-100 ns-border-box ns-text-undecorated"
                href="javascript:void(0)"
                onClick={() => {
                    setActive(!isActive)
                }}>
                <span class="ns-color-link ns-font-4">{facet.name}</span>
                {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-2 ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )}
                {isActive ? (
                    // Minus
                    <svg
                        width="16"
                        height="2"
                        viewBox="0 0 16 2"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1 1H15"
                            stroke="#3C3C3C"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                ) : (
                    // Plus
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8 1V15M1 8H15"
                            stroke="#3C3C3C"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                )}
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-pt-4">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                    {facet.data
                        ?.filter((val) => !val.value.toString().includes(':'))
                        .map((value) => (
                            <MobileFilter value={value} facet={facet} />
                        ))}
                </ul>
            </div>
        </li>
    )
}
